import React, {useState} from "react"
import {Controller, useForm} from "react-hook-form";
import dayjs from "dayjs";
import {formateDate} from "../../../utils/constant";
import {Required} from "../../../utils/patterns";
import ThemeDatePicker from "../../../components/common/date-picker/ThemeDatePicker";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {Form} from "react-bootstrap";
import {UpdateAnniversary} from "../../../services/coaching.service";
import {notification} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";


export default function EditAnniversary({clientData, close, HandleGetClientById, id}) {
    const [loader , setLoader] = useState(false)
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });


    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: id,
            anniversary: data?.aniversary_date,
        };
        try {
            let res = await  UpdateAnniversary(payload);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                reset();
                setLoader(false)
                HandleGetClientById()
                close(false)
            }
        } catch (error) {

        } finally {
            setLoader(false)
        }
    };

    return(
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={"dfields"}>
                    <Controller
                        name="aniversary_date"
                        defaultValue={
                            clientData?.anniversary
                                ? dayjs(formateDate(clientData?.anniversary), "MM/DD/YYYY")
                                : null // Explicitly set to null for an empty state
                        }
                        control={control}
                        rules={{
                            required: Required,
                        }}
                        render={({ field: { name, ...field } }) => (
                            <ThemeDatePicker
                                label={"Anniversary Date"}
                                field={field}
                                fieldName={name}
                                errors={errors.aniversary_date}
                                defaultValue={
                                    clientData?.anniversary
                                        ? dayjs(formateDate(clientData?.anniversary), "MM/DD/YYYY")
                                        : null // Explicitly set to null for an empty state
                                }
                                setValue={setValue}
                            />
                        )}
                    />
                </div>
                <div>
                    <ThemeButton
                        text={"Done"}
                        className={"btn-light-lg"}
                        type={'submit'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}